<template>
  <div style="width: 100%">
    <div class="terminal-content-tab tab" data-tab-body="results" id="results">
      <div class="results-body">
        <div class="header-bar">
          <div
            class="game-progress-lb"
            :style="{ width: `${this.gameProgress}%` }"
          ></div>
          <div
            class="result-progress-lb"
            :style="{ width: `${this.resultProgress}%` }"
          ></div>
          <div class="text-progress">
            <div class="progress-current-round">
              {{ translate("current_game_id") }} {{ currentIdToday }}
            </div>
            <div class="progress-current-time">
              {{
                this.gameTimer && this.gameTimer > 0
                  ? `${translate("draw_begins_in")} ${
                      this.gameTimer
                    } ${translate("sec")}`
                  : ""
              }}
              {{
                this.resultTimer && this.resultTimer > 0
                  ? `${translate("next_game_opens_in")}  ${
                      this.resultTimer
                    } ${translate("sec")}`
                  : ""
              }}
            </div>
            <div class="progress-current-status">
              {{
                this.gameStatus === 0
                  ? translate("open_game_status")
                  : translate("in_progress_game_status")
              }}
            </div>
          </div>
        </div>
        <div id="main-res-holder" class="results-box">
          <div class="res-holder" v-for="item in getResults(getGameResults)" :key="item.ID_Today">
            <div class="game-number-holder">
              <span style="display: flex;">
                <span>
                  <strong data-langName="round_no"></strong>
                </span>
                <div>{{ item.ID_Today }}</div>
              </span>
                
              <strong>
                <span class="date-jp-holder">
                  <span class="date-holder">
                    <span data-langName="date_and_time"></span>:
                    <span class="myspan">{{
                      item.GameTImeStart.split("T")[0] +
                      " " +
                      item.GameTImeStart.split("T")[1].split('.')[0]
                    }}</span>
                  </span>
                  
                  <span>
                    <span data-langName="jackpot_code"></span>:
                    <span class="myspan">{{ item.GameJackPotCode }}</span>
                  </span>
                </span>
                
              </strong>
            </div>

            <div class="numbers-results">
              <div
                v-bind:class="item.GameNumbersColors[index]"
                v-for="(number, index) in item.GameNumbers"
                :key="number"
              >
                <div class="">{{ number }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import $eventBus from "../../eventBus";
import { mapGetters } from "vuex";
import { translate } from "../../assets/common/lang";
import { getColorByNum } from "../../services/helpers/globals";

export default {
  props: [
    "gameTimer",
    "currentIdToday",
    "resultTimer",
    "gameStatus",
    "gameTimerMax",
    "gameTimerResultMax",
  ],
  data() {
    return {
      activated: false,
      availableDates: [],
      keyboardNumbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      maxDrawValue: 500,
      payload: {
        drawDate: null,
        drawTodayId: "",
        lang: this.$route.query.lang,
      },
    };
  },

  methods: {
    getColorByNum(n) {
      return getColorByNum(n);
    },
    clearArray(handlerArr) {
      var newRes = [];
      handlerArr.forEach(function (element) {
        if (element != "") {
          newRes.push(element);
        }
      });
      return newRes;
    },
    getResults(a) {
      let r;
      a.forEach((item, index, array) => {
        let clone = [];
        if (!item.GameNumbers.split) {
          return a;
        }
        r = item.GameNumbers.split("|");
        r = this.clearArray(r);
        r.forEach((n) => {
          clone.push("number-holder " + getColorByNum(n) + "-ball");
        });
        array[index].GameNumbers = r;
        array[index].GameNumbersColors = clone;
      });
      //console.log("GET REZ", a);
      return a;
    },
    prepareNumbers(g) {
      let numbers = g.split("|");
      return numbers;
    },
    translate(word) {
      return translate(word);
    },
    zeroPad(num, places) {
      var zero = places - num.toString().length + 1;
      return Array(+(zero > 0 && zero)).join("0") + num;
    },
    selectDate(date) {
      this.payload.drawDate = date;
    },
    selectNumber(number) {
      var tempNumber = this.payload.drawTodayId + number.toString();
      if (parseInt(tempNumber) > this.maxDrawValue) {
        return;
      }
      if (number > 0) {
        this.payload.drawTodayId = this.payload.drawTodayId + number.toString();
      } else if (parseInt(this.payload.drawTodayId) > 0) {
        this.payload.drawTodayId = this.payload.drawTodayId + number.toString();
      }
    },
    removeLatest() {
      this.payload.drawTodayId = this.payload.drawTodayId.slice(0, -1);
    },
    getDrawResults() {
      if (this.payload.drawDate === null) {
        this.$bvToast.toast(translate(`chose_date`), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }
      if (!parseInt(this.payload.drawTodayId) > 0) {
        this.$bvToast.toast(translate(`chose_game_round`), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
        return;
      }

      if (this.activated) {
        return;
      }

      this.activated = true;
      //this.$socket.emit("get-draw-results", this.payload);
    },
  },
  computed: {
    ...mapGetters(["drawResultsPrinted", "getGameResults"]),
  },
  mounted() {
    var i;
    for (i = 0; i <= 3; i++) {
      var date = null;
      date = new Date(Date.now() - i * 24 * 60 * 60 * 1000);
      var dateValue =
        date.getFullYear() +
        "-" +
        this.zeroPad(date.getMonth() + 1, 2) +
        "-" +
        this.zeroPad(date.getDate(), 2);
      var dateFormated =
        this.zeroPad(date.getDate(), 2) +
        "." +
        this.zeroPad(date.getMonth() + 1, 2) +
        "." +
        date.getFullYear();

      this.availableDates.push({ formatted: dateFormated, value: dateValue });
    }
    this.availableDates.reverse();
    // this.$store.commit("updateDrawResultsPrinted", null);
  },
  watch: {
    $props: {
      handler() {
        let rProgress = this.resultTimer / (this.gameTimerResultMax / 100);
        let gProgress = this.gameTimer / (this.gameTimerMax / 100);
        this.resultProgress = (rProgress && rProgress > 0 && rProgress) || 0;
        this.gameProgress = (gProgress && gProgress > 0 && gProgress) || 0;
      },
      deep: true,
      immediate: true,
    },
    drawResultsPrinted() {
      if (this.drawResultsPrinted) {
        $eventBus.$emit("drawResultsPrintedSuccess");
      } else {
        this.$bvToast.toast(translate(`draw_results_not_found`), {
          title: translate("notification"),
          variant: "danger",
          autoHideDelay: 3000,
          toaster: "b-toaster-top-center",
        });
      }

      this.activated = false;
      this.payload = {
        drawDate: null,
        drawTodayId: "",
        lang: this.$route.query.lang,
      };
      // this.$store.commit("updateDrawResultsPrinted", null);
    },
  },
};
</script>
